import { render, staticRenderFns } from "./upload-vaccine-docs-modal.vue?vue&type=template&id=31440c58"
import script from "./upload-vaccine-docs-modal.vue?vue&type=script&lang=js"
export * from "./upload-vaccine-docs-modal.vue?vue&type=script&lang=js"
import style0 from "./upload-vaccine-docs-modal.vue?vue&type=style&index=0&id=31440c58&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports